import React from 'react';
import { Lightbulb, TrendingUp, TrendingDown, Info, ShieldCheck, Zap } from 'lucide-react';

const InsightsTab = ({ generateInsights }) => {
  const insights = generateInsights();

  return (
    <div className="tab-pane insights-pane">
      <div className="cyber-panel">
        <div className="panel-header">
          <div className="panel-title-group">
            <Lightbulb className="panel-icon yellow" />
            <h3>AUTOMATED SYSTEM TRAFFIC INSIGHTS</h3>
          </div>
          <span className="panel-sub-tag">ANALYTICS ALGORITHMS</span>
        </div>

        <div className="panel-body">
          {insights.length === 0 ? (
            <div className="empty-state">Gathering system traffic metrics to compute insights...</div>
          ) : (
            <div className="insights-grid">
              {insights.map((item, idx) => (
                <div key={idx} className={`insight-card ${item.type}`}>
                  <div className="insight-icon">{item.icon}</div>
                  <div className="insight-text">{item.text}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InsightsTab;
